// First Created - 29 Nov 2025
// Author - Atul Pandey
// Purpose: Left Menu Items for Trinity Web Admin Portal

const adminWebMenuItems = [
  { key: "analyticsOverview", label: "Overview" },
  { key: "trafficAnalytics", label: "Traffic Analytics" },
  { key: "funnels", label: "Funnels" },
  { key: "events", label: "Event Tracking" },
  { key: "sessions", label: "Session Replay" },
  { key: "growthSparks", label: "Growth Sparks" },
  { key: "leads", label: "Lead Flow" },
  { key: "heatmaps", label: "Heatmaps" },
  { key: "utmTracking", label: "UTM Tracking" },
  { key: "pixels", label: "Pixel Status" },
  { key: "siteHealth", label: "Site Health" },
];

export default adminWebMenuItems;